import { useQuery } from "@tanstack/react-query"

import useSlugExtractor from "@hooks/useSlugExtractor"

import replaceSlugs from "@utils/replaceSlugs"

import { CATALOG_ENDPOINTS } from "@endpoints/catalogs"

export function useCatalogItemQuery(itemId: string) {
    const [itemEndpointTemplate] = useSlugExtractor([CATALOG_ENDPOINTS.ITEM_DETAILS])
    const itemEndpoint = replaceSlugs(itemEndpointTemplate, { id: itemId })

    return useQuery({
        queryKey: ["catalog-item", itemEndpoint],
        queryFn: async () => {
            const response = await fetch(itemEndpoint)

            if (!response.ok) {
                throw new Error(`Request to ${itemEndpoint} failed with status ${response.status}.`)
            }

            return (await response.json()) as CatalogItemDetails
        },
    })
}

export function useCatalogItemModifiersQuery(itemId: string) {
    const [modifiersEndpointTemplate] = useSlugExtractor([CATALOG_ENDPOINTS.ITEM_MODIFIERS])
    const modifiersEndpoint = replaceSlugs(modifiersEndpointTemplate, { id: itemId })

    return useQuery({
        queryKey: ["catalog-item-modifiers", modifiersEndpoint],
        queryFn: async () => {
            const response = await fetch(modifiersEndpoint)

            if (!response.ok) {
                throw new Error(`Request to ${modifiersEndpoint} failed with status ${response.status}.`)
            }

            return (await response.json()) as CatalogItemModifiersResponse
        },
    })
}
